import { HealthSchema, MetaSchema, ReadySchema } from '@deli/contracts';
import { useQuery } from '@tanstack/react-query';
import { getJson } from './client.js';

export const useHealth = () =>
  useQuery({
    queryKey: ['system', 'health'],
    queryFn: ({ signal }) => getJson('/health', HealthSchema, { signal }),
  });

export const useReady = () =>
  useQuery({
    queryKey: ['system', 'ready'],
    queryFn: ({ signal }) => getJson('/ready', ReadySchema, { signal, acceptStatuses: [503] }),
  });

export const useMeta = () =>
  useQuery({
    queryKey: ['system', 'meta'],
    queryFn: ({ signal }) => getJson('/api/v1/meta', MetaSchema, { signal }),
  });
